<template>
    <!-- Modal -->
    <div
        class="modal fade"
        id="terceiroLog"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modelTitleId"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-xl modal-dialog-scrollable"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Log de integração com Terceiros</h5>
                    <button
                        type="button"
                        class="close"
                        @click="fechar('terceiroLog')"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container" v-if="dados">
                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    icon="far fa-calendar fa-fw"
                                    label="Selecione o Log"
                                    placeholder="Selecione o Log"
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="dados"
                                    optionsDisplay="search"
                                    v-model="logSelecionado">
                                </az-input>
                            </div>
                        </div>

                        <template v-if="logSelecionado">
                            <div class="row mt-3">
                                <div class="col col-12">
                                    <div class="alert alert-info">
                                        <div>
                                            <span class="text-muted">Destino:</span> 
                                            {{ logSelecionado.terceiro ? logSelecionado.terceiro.search : logSelecionado.id_terceiro }}
                                        </div>
                                        <div>
                                            <span class="text-muted">URL:</span> 
                                            {{ logSelecionado.st_url }}
                                        </div>
                                    </div>

                                    <template v-if="logSelecionado.st_xml_envio && logSelecionado.st_xml_envio != 'null'">
                                        <div class="d-flex justify-content-between">
                                            <div>Envio</div>
                                            <div class="small">
                                                <a href="#" :class="view_envio == 'T' ? 'font-weight-bold' : ''" @click.prevent="view_envio = 'T'">
                                                    Texto
                                                </a>
                                                | 
                                                <a href="#" :class="view_envio == 'F' ? 'font-weight-bold' : ''" @click.prevent="view_envio = 'F'">
                                                    Formatado
                                                </a>
                                                | 
                                                <a href="#" :class="view_envio == 'O' ? 'font-weight-bold' : ''" @click.prevent="view_envio = 'O'">
                                                    Ocultar
                                                </a>
                                            </div>
                                        </div>

                                        <div class="alert alert-warning" v-if="view_envio == 'F'">
                                            <vue-json-pretty :data="parse_json(logSelecionado.st_xml_envio)" :showLength="true" />
                                        </div>

                                        <pre class="alert alert-warning text-wrap w-100" v-else-if="view_envio == 'T'">{{ logSelecionado.st_xml_envio }}</pre>
                                    </template>

                                    <div class="d-flex justify-content-between">
                                        <div>Retorno</div>
                                        <div class="small">
                                            <a href="#" :class="view_retorno == 'T' ? 'font-weight-bold' : ''" @click.prevent="view_retorno = 'T'">
                                                Texto
                                            </a>
                                            | 
                                            <a href="#" :class="view_retorno == 'F' ? 'font-weight-bold' : ''" @click.prevent="view_retorno = 'F'">
                                                Formatado
                                            </a>
                                            | 
                                            <a href="#" :class="view_retorno == 'O' ? 'font-weight-bold' : ''" @click.prevent="view_retorno = 'O'">
                                                Ocultar
                                            </a>
                                        </div>
                                    </div>

                                    <div class="alert alert-secondary" v-if="view_retorno == 'F'">
                                        <vue-json-pretty :data="parse_json(logSelecionado.st_xml_retorno)" :showLength="true" />
                                    </div>

                                    <pre class="alert alert-secondary text-wrap w-100" v-if="view_retorno == 'T'">{{ logSelecionado.st_xml_retorno }}</pre>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="fechar('terceiroLog')"
                    >
                        Fechar
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from "../../shared/forms/AzInput.vue";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    data() {
        return {
            dados: null,
            logSelecionado: null, 
            view_envio: 'T', 
            view_retorno: 'T', 
        };
    },

    components: {
        AzInput,
        VueJsonPretty
    },

    methods: {
        parse_json (texto) { 
            return JSON.parse(texto);
        },

        fechar(modal) {
            $("#" + modal).modal("hide");
        },
        exibir_log(id_atendimento) {
            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "terceiro_logs",
                dados: {
                    id_atendimento: id_atendimento
                },
                callback: res => {
                    this.dados = res;
                    $("#terceiroLog").modal("show");
                }
            });
        }
    }
};
</script>

<style></style>
